import {h} from 'ui/Framework';

export default h('svg', {
  width: '17',
  height: '14',
  viewBox: '-1 -1 19 16',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      stroke: '#D6DCE4',
      fill: '#FFF'
    }, [
      h('g', [
        h('path', {
          d: 'M1.147 13.285L8.462.336l7.366 13.037'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/arrow-up.es6.js